import { render, staticRenderFns } from "./PatientProfileTrustInfo.vue?vue&type=template&id=5830e3b6&"
import script from "./PatientProfileTrustInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PatientProfileTrustInfo.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5830e3b6')) {
      api.createRecord('5830e3b6', component.options)
    } else {
      api.reload('5830e3b6', component.options)
    }
    module.hot.accept("./PatientProfileTrustInfo.vue?vue&type=template&id=5830e3b6&", function () {
      api.rerender('5830e3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PatientProfile/components/common/PatientProfileTrustInfo.vue"
export default component.exports